module.exports = __webpack_public_path__ + "static/media/desktopComputer.8fc00784.png";